<app-modal
  [title]="'Aktion' | trans:'actions/actions-modal/header/title'"
  maxWidth="1200px"
  minWidth="30%"
  width="fit-content"
  [compact]="true"
>
  <ng-template>
    <div class="actions-buttons-wrapper d-grid gap-12">
      <button
        class="button button--quick-action"
        (click)="nonTakenReservationsToReleaseModalComponent.open()"
      >
        <i class="ri-calendar-close-line"></i>
        {{ 'Reservierungen freigeben' | trans:'actions/actions-modal/buttons/releaseReservations.Button' }}
      </button>
      <button
        class="button button--quick-action"
        (click)="generateEmployeeSessionReport()"
      >
        <i class="ri-file-list-3-line"></i>
        {{ 'Bedienerbericht' | trans:'actions/actions-modal/buttons/employeeSessionReport.Button' }}
      </button>
      <button
        class="button button--quick-action"
        [disabled]="isClearCacheButtonDisabled()"
        (click)="clearCache()"
      >
        <i class="ri-eraser-line"></i>
        {{ 'Cache-Speicher leeren' | trans:'actions/actions-modal/buttons/clear cache.Button' }}
      </button>
    </div>

    <div class="separator"></div>

    <div class="actions-buttons-wrapper d-grid gap-12">
      <button class="button button--quick-action" (click)="printLastReceipt()">
        <i class="ri-bill-line"></i>
        {{ 'Kaufquittung drucken (letzte)' | trans:'actions/actions-modal/buttons/printLastBill.Button' }}
      </button>
      <button class="button button--quick-action" (click)="printLastInvoice()">
        <i class="ri-article-line"></i>
        {{ 'Rechnung drucken (letzte)' | trans:'actions/actions-modal/buttons/printLastInvoice.Button' }}
      </button>
      <button class="button button--quick-action" (click)="terminalSessionTransactionsModalComponent.open()">
        <i class="ri-receipt-line"></i>
        {{ 'Kaufquittung drucken...' | trans:'actions/actions-modal/buttons/printBill.Button' }}
      </button>
    </div>

    <div class="separator"></div>

    <div class="actions-buttons-wrapper d-grid gap-12">
      <button
        class="button button--quick-action"
        [appWebCashPermissionControl]="permissionKeys.WebCxCashSafes"
        [extraDisabled]="!terminalParametersMap()[terminalParameterKeys.CSH_SAFE_PORT] || isTerminalWithoutSafe"
        (click)="openSafe()"
      >
        <i class="ri-coin-line"></i>
        {{ 'Kassenschublade öffnen' | trans:'actions/actions-modal/buttons/openSafe.Button' }}
      </button>
    </div>

    <div class="separator"></div>

    <div class="actions-buttons-wrapper d-grid gap-12">
      <button class="button button--quick-action" (click)="ticketNumberModal.open()">
        <i class="ri-book-open-line"></i>
        {{ 'Ticket ablesen' | trans:'actions/actions-modal/buttons/ticketDetails.Button' }}
      </button>
      <button class="button button--quick-action" disabled>
        <i class="ri-refresh-line"></i>
        {{ 'Ticket-Rolle wechseln...' | trans:'actions/actions-modal/buttons/changeTicketRoll.Button' }}
      </button>
      <button class="button button--quick-action" disabled>
        <i class="ri-refresh-line"></i>
        {{ 'Ticket-Schwund gedruckt...' | trans:'actions/actions-modal/buttons/ticketLossPrinted.Button' }}
      </button>
      <button class="button button--quick-action" disabled>
        <i class="ri-refresh-line"></i>
        {{ 'Ticket-Schwund ungedruckt...' | trans:'actions/actions-modal/buttons/ticketLossUnPrinted.Button' }}
      </button>
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ 'Cancel' | trans:'actions/actions-modal/cancel.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>

<app-ticket-number-modal
  #ticketNumberModal
  (confirm)="ticketDetailsModalComponent.open({ ticketNr: $event })"
/>

<app-ticket-details-modal #ticketDetailsModalComponent />

<app-non-taken-reservations-to-release-modal #nonTakenReservationsToReleaseModalComponent />

<app-terminal-session-transactions-modal #terminalSessionTransactionsModalComponent />

<app-pdf-viewer-modal #pdfViewerModalComponent />
